import type { PrimitiveAtom } from 'jotai';
import { atom, type createStore } from 'jotai/vanilla';
import type { State } from 'types/redux';
import type { Raw, ReviewPill } from 'types/vendor';

export const reviewPillsAtom: PrimitiveAtom<ReviewPill[] | null> = atom<
	ReviewPill[] | null
>(null);

export const setReviewPillsData = (
	store: ReturnType<typeof createStore>,
	storefrontData: Raw,
	_reduxState: State,
) => {
	const reviewPills = storefrontData.reviewsPills ?? [];
	if (reviewPills.length === 0) {
		store.set(reviewPillsAtom, null);
		return;
	}

	const sortedReviewPills = [...reviewPills].sort(
		(a, b) => a.position - b.position,
	);
	store.set(reviewPillsAtom, sortedReviewPills);
};

export const getReviewPillsDataToHydrate = (
	store: ReturnType<typeof createStore>,
) => {
	return {
		reviewPills: store.get(reviewPillsAtom),
	};
};

export const getReviewPillsInitialValues = (
	values: ReturnType<typeof getReviewPillsDataToHydrate>,
): Array<[typeof reviewPillsAtom, ReviewPill[] | null]> => {
	return [[reviewPillsAtom, values?.reviewPills ?? null]];
};
